// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710.004%27 height=%2713.019%27%3E%3Cpath fill=%27%234694ce%27 d=%27M.303 6.086a.99.99 0 0 0 1.461 0l2.2-2.341v8.177a1.035 1.035 0 1 0 2.066 0V3.744l2.206 2.341a.99.99 0 0 0 1.461 0 1.145 1.145 0 0 0 0-1.551L5.727.32a1.033 1.033 0 0 0-.335-.236.963.963 0 0 0-.79 0 1.035 1.035 0 0 0-.335.236L.299 4.534a1.145 1.145 0 0 0 .004 1.552z%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710.004%27 height=%2713.019%27%3E%3Cpath fill=%27%234694ce%27 d=%27M9.701 6.933a.99.99 0 0 0-1.461 0l-2.2 2.341V1.097a1.035 1.035 0 1 0-2.066 0v8.178L1.768 6.934a.99.99 0 0 0-1.461 0 1.145 1.145 0 0 0 0 1.551l3.97 4.214a1.033 1.033 0 0 0 .335.236.963.963 0 0 0 .79 0 1.035 1.035 0 0 0 .335-.236l3.968-4.214a1.145 1.145 0 0 0-.004-1.552z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: auto;
}
.ReactTable * {
  box-sizing: border-box;
}
.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-collapse: collapse;
  overflow-x: auto;
  overflow-y: hidden;
}
.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  user-select: none;
}
.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
}
.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid rgba(0, 0, 0, 0.02);
}
.ReactTable .rt-thead.-header {
  background-color: rgba(247, 250, 252, 1);
  border-bottom: 2px solid #ddd;
}
.ReactTable .rt-thead .rt-tr {
  text-align: left;
}
.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}
.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);
}
.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);
}
.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer:hover {
  background-color: rgb(244, 250, 253);
}
.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-thead .rt-resizable-header {
  outline: none;
}
.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}
.ReactTable .rt-thead .rt-resizable-header-content {
  color: rgba(86, 96, 114, 1);
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.02rem;
  padding: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}
.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}
.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}
.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}
.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}
.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.02);
  padding: 0.9rem;
  color: rgb(68, 68, 68, 1);
}
.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}
.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}
.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 7px 5px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}
.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}
.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}
.ReactTable .rt-expander:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}
.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}
.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}
.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}
.ReactTable.-striped .rt-tr.-odd {
  background: rgba(255, 255, 255, 1);
}
.ReactTable.-striped .rt-tr.-even {
  background: rgba(255, 255, 255, 1);
}
.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(255, 255, 255, 0.05);
}
.ReactTable .-pagination {
  z-index: 1;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 1rem;
  display: inline-flex;
  float: right;
}
.ReactTable .-pagination input,
.ReactTable .-pagination select {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
}
.ReactTable .-pagination .-btn {
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.6);
  background: #fff;
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}
.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}
.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}
.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1;
  text-align: center;
}
.ReactTable .-pagination .-previous a:not([disabled]),
.ReactTable .-pagination .-next a:not([disabled]) {
  cursor: pointer;
}
.ReactTable .-pagination .-center {
  flex: 1.5;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 25px;
  white-space: nowrap;
}
.ReactTable .-pagination .-pageJump {
  display: inline-block;
}
.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}
.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}
.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 65%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}
.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}
.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  user-select: none;
}

/************ Custom mods **********/

.ReactTable .rt-resizable-header {
  padding: 6px 24px 6px 0 !important;
  box-shadow: none !important;
}

.ReactTable .rt-resizer:before {
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 15px;
  height: 18px;
  width: 18px;
  color: transparent;
  content: '.';
  background-size: 11px 14px;
  background-repeat: no-repeat;
}

.ReactTable .rt-th.-sort-asc .rt-resizer:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ReactTable .rt-th.-sort-desc .rt-resizer:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.table_title {
  display: inline-block;
  font-size: 2rem;
  padding: 2rem;
  color: #444;
}
.table_title span {
  color: #4694ce;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/GuestVMs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,mEAAmE;EACnE,qCAAqC;AACvC;AACA;;EAEE,8CAA8C;AAChD;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;EACxC,4DAA4D;EAC5D,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;AACA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,OAAO;EACP,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,yDAAyD;AAC3D;AACA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oCAAoC;;AAEpC;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yDAA2a;AAC7a;AACA;EACE,yDAA+a;AACjb;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;AAChB","sourcesContent":[".ReactTable {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  width: auto;\r\n}\r\n.ReactTable * {\r\n  box-sizing: border-box;\r\n}\r\n.ReactTable .rt-table {\r\n  flex: auto 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  border-collapse: collapse;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n.ReactTable .rt-thead {\r\n  flex: 1 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  user-select: none;\r\n}\r\n.ReactTable .rt-thead.-headerGroups {\r\n  background: rgba(0, 0, 0, 0.03);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n.ReactTable .rt-thead.-filters {\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n.ReactTable .rt-thead.-filters input,\r\n.ReactTable .rt-thead.-filters select {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n  padding: 5px 7px;\r\n  font-size: inherit;\r\n  border-radius: 3px;\r\n  font-weight: normal;\r\n  outline: none;\r\n}\r\n.ReactTable .rt-thead.-filters .rt-th {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.02);\r\n}\r\n.ReactTable .rt-thead.-header {\r\n  background-color: rgba(247, 250, 252, 1);\r\n  border-bottom: 2px solid #ddd;\r\n}\r\n.ReactTable .rt-thead .rt-tr {\r\n  text-align: left;\r\n}\r\n.ReactTable .rt-thead .rt-th,\r\n.ReactTable .rt-thead .rt-td {\r\n  padding: 5px 5px;\r\n  line-height: normal;\r\n  position: relative;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  box-shadow: inset 0 0 0 0 transparent;\r\n}\r\n.ReactTable .rt-thead .rt-th.-sort-asc,\r\n.ReactTable .rt-thead .rt-td.-sort-asc {\r\n  box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);\r\n}\r\n.ReactTable .rt-thead .rt-th.-sort-desc,\r\n.ReactTable .rt-thead .rt-td.-sort-desc {\r\n  box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);\r\n}\r\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\r\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n.ReactTable .rt-thead .rt-th.-cursor-pointer:hover {\r\n  background-color: rgb(244, 250, 253);\r\n}\r\n.ReactTable .rt-thead .rt-th:last-child,\r\n.ReactTable .rt-thead .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n.ReactTable .rt-thead .rt-resizable-header {\r\n  outline: none;\r\n}\r\n.ReactTable .rt-thead .rt-resizable-header:last-child {\r\n  overflow: hidden;\r\n}\r\n.ReactTable .rt-thead .rt-resizable-header-content {\r\n  color: rgba(86, 96, 114, 1);\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02rem;\r\n  padding: 0.9rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.ReactTable .rt-thead .rt-header-pivot {\r\n  border-right-color: #f7f7f7;\r\n}\r\n.ReactTable .rt-thead .rt-header-pivot:after,\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n  left: 100%;\r\n  top: 50%;\r\n  border: solid transparent;\r\n  content: ' ';\r\n  height: 0;\r\n  width: 0;\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n.ReactTable .rt-thead .rt-header-pivot:after {\r\n  border-color: rgba(255, 255, 255, 0);\r\n  border-left-color: #fff;\r\n  border-width: 8px;\r\n  margin-top: -8px;\r\n}\r\n.ReactTable .rt-thead .rt-header-pivot:before {\r\n  border-color: rgba(102, 102, 102, 0);\r\n  border-left-color: #f7f7f7;\r\n  border-width: 10px;\r\n  margin-top: -10px;\r\n}\r\n.ReactTable .rt-tbody {\r\n  flex: 99999 1 auto;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: visible;\r\n}\r\n.ReactTable .rt-tbody .rt-tr-group {\r\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\r\n}\r\n.ReactTable .rt-tbody .rt-tr-group:last-child {\r\n  border-bottom: 0;\r\n}\r\n.ReactTable .rt-tbody .rt-td {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.02);\r\n  padding: 0.9rem;\r\n  color: rgb(68, 68, 68, 1);\r\n}\r\n.ReactTable .rt-tbody .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n.ReactTable .rt-tbody .rt-expandable {\r\n  cursor: pointer;\r\n  text-overflow: clip;\r\n}\r\n.ReactTable .rt-tr-group {\r\n  flex: 1 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n}\r\n.ReactTable .rt-tr {\r\n  flex: 1 0 auto;\r\n  display: inline-flex;\r\n}\r\n.ReactTable .rt-th,\r\n.ReactTable .rt-td {\r\n  flex: 1 0 0;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  padding: 7px 5px;\r\n  overflow: hidden;\r\n  transition: 0.3s ease;\r\n  transition-property: width, min-width, padding, opacity;\r\n}\r\n.ReactTable .rt-th.-hidden,\r\n.ReactTable .rt-td.-hidden {\r\n  width: 0 !important;\r\n  min-width: 0 !important;\r\n  padding: 0 !important;\r\n  border: 0 !important;\r\n  opacity: 0 !important;\r\n}\r\n.ReactTable .rt-expander {\r\n  display: inline-block;\r\n  position: relative;\r\n  margin: 0;\r\n  color: transparent;\r\n  margin: 0 10px;\r\n}\r\n.ReactTable .rt-expander:after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%) rotate(-90deg);\r\n  border-left: 5.04px solid transparent;\r\n  border-right: 5.04px solid transparent;\r\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\r\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  cursor: pointer;\r\n}\r\n.ReactTable .rt-expander.-open:after {\r\n  transform: translate(-50%, -50%) rotate(0);\r\n}\r\n.ReactTable .rt-resizer {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 36px;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: -18px;\r\n  cursor: col-resize;\r\n  z-index: 10;\r\n}\r\n.ReactTable .rt-tfoot {\r\n  flex: 1 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\r\n}\r\n.ReactTable .rt-tfoot .rt-td {\r\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n.ReactTable .rt-tfoot .rt-td:last-child {\r\n  border-right: 0;\r\n}\r\n.ReactTable.-striped .rt-tr.-odd {\r\n  background: rgba(255, 255, 255, 1);\r\n}\r\n.ReactTable.-striped .rt-tr.-even {\r\n  background: rgba(255, 255, 255, 1);\r\n}\r\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n.ReactTable .-pagination {\r\n  z-index: 1;\r\n  justify-content: space-between;\r\n  align-items: stretch;\r\n  flex-wrap: wrap;\r\n  padding: 1rem;\r\n  display: inline-flex;\r\n  float: right;\r\n}\r\n.ReactTable .-pagination input,\r\n.ReactTable .-pagination select {\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n  padding: 5px 7px;\r\n  font-size: inherit;\r\n  border-radius: 3px;\r\n  font-weight: normal;\r\n  outline: none;\r\n}\r\n.ReactTable .-pagination .-btn {\r\n  appearance: none;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n  border-radius: 3px;\r\n  padding: 6px;\r\n  font-size: 1em;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  background: #fff;\r\n  transition: all 0.1s ease;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n.ReactTable .-pagination .-btn[disabled] {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n.ReactTable .-pagination .-btn:not([disabled]):hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n  color: #fff;\r\n}\r\n.ReactTable .-pagination .-previous,\r\n.ReactTable .-pagination .-next {\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n.ReactTable .-pagination .-previous a:not([disabled]),\r\n.ReactTable .-pagination .-next a:not([disabled]) {\r\n  cursor: pointer;\r\n}\r\n.ReactTable .-pagination .-center {\r\n  flex: 1.5;\r\n  text-align: center;\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n}\r\n.ReactTable .-pagination .-pageInfo {\r\n  display: inline-block;\r\n  margin: 3px 25px;\r\n  white-space: nowrap;\r\n}\r\n.ReactTable .-pagination .-pageJump {\r\n  display: inline-block;\r\n}\r\n.ReactTable .-pagination .-pageJump input {\r\n  width: 70px;\r\n  text-align: center;\r\n}\r\n.ReactTable .-pagination .-pageSizeOptions {\r\n  margin: 3px 10px;\r\n}\r\n.ReactTable .rt-noData {\r\n  display: block;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 65%;\r\n  transform: translate(-50%, -50%);\r\n  background: rgba(255, 255, 255, 0.8);\r\n  transition: all 0.3s ease;\r\n  z-index: 1;\r\n  pointer-events: none;\r\n  padding: 20px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n}\r\n.ReactTable .-loading {\r\n  display: block;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  background: rgba(255, 255, 255, 0.8);\r\n  transition: all 0.3s ease;\r\n  z-index: -1;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n.ReactTable .-loading > div {\r\n  position: absolute;\r\n  display: block;\r\n  text-align: center;\r\n  width: 100%;\r\n  top: 50%;\r\n  left: 0;\r\n  font-size: 15px;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  transform: translateY(-52%);\r\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n.ReactTable .-loading.-active {\r\n  opacity: 1;\r\n  z-index: 2;\r\n  pointer-events: all;\r\n}\r\n.ReactTable .-loading.-active > div {\r\n  transform: translateY(50%);\r\n}\r\n.ReactTable .rt-resizing .rt-th,\r\n.ReactTable .rt-resizing .rt-td {\r\n  transition: none !important;\r\n  cursor: col-resize;\r\n  user-select: none;\r\n}\r\n\r\n/************ Custom mods **********/\r\n\r\n.ReactTable .rt-resizable-header {\r\n  padding: 6px 24px 6px 0 !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.ReactTable .rt-resizer:before {\r\n  display: inline-block;\r\n  position: absolute;\r\n  right: 20px;\r\n  top: 15px;\r\n  height: 18px;\r\n  width: 18px;\r\n  color: transparent;\r\n  content: '.';\r\n  background-size: 11px 14px;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.ReactTable .rt-th.-sort-asc .rt-resizer:before {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10.004' height='13.019'%3E%3Cpath fill='%234694ce' d='M.303 6.086a.99.99 0 0 0 1.461 0l2.2-2.341v8.177a1.035 1.035 0 1 0 2.066 0V3.744l2.206 2.341a.99.99 0 0 0 1.461 0 1.145 1.145 0 0 0 0-1.551L5.727.32a1.033 1.033 0 0 0-.335-.236.963.963 0 0 0-.79 0 1.035 1.035 0 0 0-.335.236L.299 4.534a1.145 1.145 0 0 0 .004 1.552z' /%3E%3C/svg%3E\");\r\n}\r\n.ReactTable .rt-th.-sort-desc .rt-resizer:before {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10.004' height='13.019'%3E%3Cpath fill='%234694ce' d='M9.701 6.933a.99.99 0 0 0-1.461 0l-2.2 2.341V1.097a1.035 1.035 0 1 0-2.066 0v8.178L1.768 6.934a.99.99 0 0 0-1.461 0 1.145 1.145 0 0 0 0 1.551l3.97 4.214a1.033 1.033 0 0 0 .335.236.963.963 0 0 0 .79 0 1.035 1.035 0 0 0 .335-.236l3.968-4.214a1.145 1.145 0 0 0-.004-1.552z'/%3E%3C/svg%3E\");\r\n}\r\n.table_title {\r\n  display: inline-block;\r\n  font-size: 2rem;\r\n  padding: 2rem;\r\n  color: #444;\r\n}\r\n.table_title span {\r\n  color: #4694ce;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
